'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _chemist = require('chemist');

var _reactI18next = require('react-i18next');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

var _translate = require('../../helpers/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckoutContact = (_dec = (0, _chemist.configurable)(), _dec2 = (0, _reactI18next.translate)(), _dec3 = (0, _reactCssModules2.default)(_style2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = function (_React$Component) {
  (0, _inherits3.default)(CheckoutContact, _React$Component);

  function CheckoutContact() {
    (0, _classCallCheck3.default)(this, CheckoutContact);
    return (0, _possibleConstructorReturn3.default)(this, (CheckoutContact.__proto__ || (0, _getPrototypeOf2.default)(CheckoutContact)).apply(this, arguments));
  }

  (0, _createClass3.default)(CheckoutContact, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          code = _props.config.store.code;

      var phone = (0, _translate.contextualTranslation)(t, code, 'checkout_contact_block.telephone');
      var text1 = (0, _translate.contextualTranslation)(t, code, 'checkout_contact_block.text_1');
      var text2 = (0, _translate.contextualTranslation)(t, code, 'checkout_contact_block.text_2');
      var text3 = (0, _translate.contextualTranslation)(t, code, 'checkout_contact_block.text_3');

      return _react2.default.createElement(
        'div',
        { styleName: 'contact-info-block' },
        _react2.default.createElement(
          'p',
          null,
          text1
        ),
        _react2.default.createElement(
          'p',
          null,
          text2,
          ' ',
          _react2.default.createElement(
            'a',
            { styleName: 'a-link', href: 'tel:' + phone },
            'Tel: ',
            phone
          ),
          _react2.default.createElement('br', null),
          text3
        )
      );
    }
  }]);
  return CheckoutContact;
}(_react2.default.Component)) || _class) || _class) || _class);
exports.default = CheckoutContact;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/CheckoutContact/index.js
// module id = 533
// module chunks = 0